import { Model } from '../model';
import { ChatMessageType } from './lead.client.whatsapp.chatmessagetype';
import { MessageStatus } from './lead.client.whatsapp.messagestatus';
import { PoviderType } from './lead.client.whatsapp.providertype';

export class LeadClientWhatsappMessage extends Model {
    public file?: Blob;
    public fileUrl?: string;

    constructor(
        public id?: number,
        public poviderType?: PoviderType,
        public createDate?: Date,
        public leadClientID?: number,
        public messageType?: ChatMessageType,
        public message?: string,
        public senderOrigin?: string,
        public senderDestination?: string,
        public userId?: number,
        public messageContentType?: string,
        public whatsappMessageId?: string,
        public messageStatus?: MessageStatus,
        public errorDetails?: string,
        public channelId?: number,
        public adName?: string,
        public adGroupId?: string,
        public adId?: string,
        public filename?: string,

        public adPreview?: string,
        public imgSrc?: string,
        public referralData?: string,
    ) {
        super();
    }
}
